import * as React from 'react';
import { Button, Dialog, DialogActions, DialogTitle, LinearProgress } from '@mui/material';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import { useTranslation } from "react-i18next";
import { useStores } from '../../../stores';
import { AccountingSummary } from '../../../domain/AccountingSummary';
import AccountingSummaryTable from '../AccountingSummaryTable';
import { withLazyMounting } from '../../../components/hoc/LazyDialog';

interface Props {
    isOpen: boolean;
    date: Date;
    onClose: () => void;
}

const AccountingSummaryDialog = observer((props: Props) => {
    const { t } = useTranslation();
    const { serverStore, accountingStore } = useStores();
    const [summary, setSummary] = React.useState<AccountingSummary>();

    React.useEffect(() => {
        if (props.isOpen) {
            accountingStore.getSummary(moment(props.date).format("YYYY-MM"), "month", (summary) => {
                setSummary(summary);
            });
        }
    }, [accountingStore, props.isOpen]);

    return (
        <Dialog fullWidth maxWidth="md" open={props.isOpen} onClose={props.onClose}>
            <DialogTitle>{t("summary")}</DialogTitle>
            {serverStore.serverRequestLoading && <LinearProgress />}
            <AccountingSummaryTable summary={summary} />
            <DialogActions>
                <Button onClick={props.onClose}>{t("close")}</Button>
            </DialogActions>
        </Dialog>
    );
});

export default withLazyMounting(AccountingSummaryDialog);
